import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import CompetitionGroupModal from "@/Modals/WebDataManagement/MasterData/CompetitionGroups/Modal";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import { columns } from "./Columns";
import { competitionGroupsMasterDataApi } from "@/apis/apis";
import { useFilters } from "./Filters";

export default function CompetitionGroupsPage() {
  const filters = useFilters();

  return (
    <MasterDataBaseTable
      label="Competition Group"
      apiURL={competitionGroupsMasterDataApi}
      columns={columns()}
      filters={filters}
      ModalComponent={CompetitionGroupModal}
      importData={BASE_IMPORT_DATA.COMPETITION_GROUPS}
      enableSortData={true}
    />
  );
}
